import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
//Actions
import {
    accountPurgeAccountRequest,
    accountPurgeAccountCloseModal,
    clearRedux,
} from "Redux/actions";

const PurgeAccount = () => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const {
        account,
        loading,
        openModal,
        result
    } = useSelector(state => state.purgeAccountRedux);

    const closeModal = () => {
        dispatch(accountPurgeAccountCloseModal());
        dispatch(clearRedux("PURGE_ACCOUNT"));
    }

    const handleSave = () => {
        dispatch(accountPurgeAccountRequest(account?.id));
    }

    useEffect(() => {
        if (result && !result.error) {
            NotificationManager.success(
                messages['account_purge_account_success_response'],
                messages['account_purge_account_title'],
                3000,
                null,
                null,
                'success'
            );
            closeModal();
        } else if(result?.error) {
            NotificationManager.error(
                messages['account_purge_account_error_response'],
                messages['account_purge_account_title'],
                3000,
                null,
                null,
                'error'
            );
            closeModal();
        }
    }, [result]);

    return (
        <Modal
            open={openModal}
            title={`${messages['account_purge_account_title']} ${account && ` - ${account.name}`}`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <p>{messages['account_purge_account_label']}</p>
                </div>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        className="btn btn-cancel"
                        onClick={(e) => {
                            e.preventDefault();
                            closeModal();
                        }}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        onClick={(e) => {
                            e.preventDefault();
                            handleSave();
                        }}
                        className="btn-dark-blue"
                    >
                        {messages['account_purge_account_resync']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default PurgeAccount;